// extracted by mini-css-extract-plugin
module.exports = {"featureList":"list-styles-module--featureList--2YW1v"};